export const getActiveNavigationValue = (pathname, navigationTabs) => {
  const currentTab = navigationTabs.find((tab) => pathname.startsWith(tab.value));

  return currentTab?.value || pathname;
};
